module.exports = __webpack_public_path__ + "img/device2.62b914a8.png";